import React from 'react';
import { Button, Form, } from 'reactstrap';
import { mapValues } from 'lodash';
import { useToggle } from 'react-use';

import useFormState from '../hooks/useFormState';
import Field from '../Field';
import { fieldsToSignUp } from '../../shared/models/user';

const { entries } = Object;

export default function SignUpForm(props) {
  const { isOpen, values, } = props;
  const [isSubmitting, toggleSubmitting] = useToggle();
  const statedFields = useFormState(values, fieldsToSignUp, isOpen);
  const isUnsubmittable = Object.values(statedFields).some(_ => !_.isValid);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;
    toggleSubmitting(true);
    await props.onSubmit({ ...mapValues(statedFields, 'value') });
    toggleSubmitting(false);
  };

  return (
    <Form onSubmit={onSubmit}>
      <h2 className="my-4 text-center">
        <div>新規お申し込み</div>
      </h2>
      <div>
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => (
            <Field
              documentName="user"
              key={fieldName}
              name={fieldName}
              {...fieldSetting}
            />
          ))
        }
      </div>
      <div>
        <Button block type="submit" color="primary" outline onClick={onSubmit} disabled={isUnsubmittable || isSubmitting}>{isSubmitting ? '登録中...' : '登録'}</Button>
      </div>
      <div className="text-muted mt-2">
        ログインは
        <a href="/">
          こちら
        </a>
      </div>
    </Form>
  );
};
